import React from "react"
import { SelectedFilterCategory } from "../types"
import FilterCategoryContainer from "./FilterCategoryContainer"
import FiltersModalBrandFilter from "./FiltersModalBrandFilter"
import FiltersModalCategoriesList from "./FiltersModalCategoriesList"
import FiltersModalPriceFilter from "./FiltersModalPriceFilter"
import FiltersModalProductCategoriesFilter from "./FiltersModalProductCategoriesFilter"
import FiltersModalTagFilter from "./FiltersModalTagFilter"

interface Props {
  selectedCategory?: SelectedFilterCategory
  onSelectedCategoryChange: (category: SelectedFilterCategory) => void
  onSelectedCategoryClear: () => void
}

const FiltersModalContent = ({
  onSelectedCategoryChange,
  onSelectedCategoryClear,
  selectedCategory,
}: Props) => {
  return (
    <>
      {!selectedCategory && (
        <FiltersModalCategoriesList
          onSelectedCategoryChange={onSelectedCategoryChange}
        />
      )}
      <FiltersModalProductCategoriesFilter
        show={selectedCategory?.type === "category"}
        onClose={onSelectedCategoryClear}
      />
      <FilterCategoryContainer
        show={selectedCategory?.type === "brand"}
        onBack={onSelectedCategoryClear}
      >
        <FiltersModalBrandFilter />
      </FilterCategoryContainer>
      <FilterCategoryContainer
        show={selectedCategory?.type === "price"}
        onBack={onSelectedCategoryClear}
      >
        <FiltersModalPriceFilter />
      </FilterCategoryContainer>
      <FilterCategoryContainer
        show={selectedCategory?.type === "tag"}
        onBack={onSelectedCategoryClear}
      >
        <FiltersModalTagFilter category={selectedCategory?.item} />
      </FilterCategoryContainer>
    </>
  )
}

export default FiltersModalContent
